class AnnouncementRibbon extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.messages = [...this.querySelectorAll('[data-announcement-message]')];
    if (this.messages.length < 2) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.index = Math.max(0, this.messages.findIndex(message => !message.hidden));
    this.hovered = false;
    this.editorSelected = false;
    this.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
    }, { signal });
    this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
    this.addEventListener('pointerdown', () => this.schedule(), { signal, passive: true });
    this.addEventListener('focusin', () => this.schedule(), { signal });
    this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), { signal });
    this.motion.addEventListener('change', () => this.updateMotion(), { signal });
    document.addEventListener('visibilitychange', () => this.schedule(), { signal });
    this.addEventListener('shopify:block:select', event => {
      const index = this.messages.indexOf(event.target.closest('[data-announcement-message]'));
      if (index < 0) return;
      this.editorSelected = true;
      this.show(index);
    }, { signal });
    this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, { signal });
    this.updateMotion();
  }

  updateMotion() {
    this.toggleAttribute('data-enhanced', !this.motion.matches);
    this.show(this.index);
  }

  show(index, animate = false) {
    clearTimeout(this.transitionTimer);
    this.index = (index + this.messages.length) % this.messages.length;
    this.messages.forEach((message, position) => {
      message.removeAttribute('data-leaving');
      message.removeAttribute('data-entering');
      if (position === this.index) return;
      message.hidden = true;
      message.inert = true;
      message.setAttribute('aria-hidden', 'true');
      message.removeAttribute('data-current');
    });
    const message = this.messages[this.index];
    message.hidden = false;
    message.inert = false;
    message.setAttribute('aria-hidden', 'false');
    message.setAttribute('data-current', '');
    message.toggleAttribute('data-entering', animate && !this.motion.matches);
    this.schedule();
  }

  schedule() {
    clearTimeout(this.timer);
    clearTimeout(this.transitionTimer);
    this.messages[this.index].removeAttribute('data-leaving');
    if (!this.isConnected || this.motion.matches || this.hovered || this.editorSelected || document.hidden || this.contains(document.activeElement)) return;
    // A full reading interval after interaction prevents abrupt idle resumption.
    this.timer = setTimeout(() => {
      this.messages[this.index].setAttribute('data-leaving', '');
      this.transitionTimer = setTimeout(() => this.show(this.index + 1, true), 200);
    }, 7000);
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    clearTimeout(this.transitionTimer);
    this.controller?.abort();
    this.controller = null;
    this.removeAttribute('data-enhanced');
    this.messages?.forEach(message => { message.removeAttribute('data-leaving'); message.removeAttribute('data-entering'); });
  }
}

if (!customElements.get('announcement-ribbon')) customElements.define('announcement-ribbon', AnnouncementRibbon);
